<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Report Scheduler' }}</h2>
      <p>Recurring COI &amp; payment reports — Excel files delivered over email and WhatsApp (IST).</p>
    </div>
    <div class="head-actions">
      @if (activeTab() === 'schedules') {
        <p-button label="All Logs" icon="pi pi-history" [outlined]="true" (onClick)="openLogs(null)" />
        <p-button label="New Schedule" icon="pi pi-plus" (onClick)="openAdd()" />
      } @else {
        <p-button label="New Template" icon="pi pi-plus" (onClick)="openTplAdd()" />
      }
    </div>
  </div>

  <div class="card tabs-card">
    <p-tabs [value]="activeTab()" (valueChange)="setTab($event)">
      <p-tablist>
        <p-tab value="schedules"><i class="pi pi-calendar-clock"></i> Schedules</p-tab>
        <p-tab value="templates"><i class="pi pi-table"></i> Templates</p-tab>
      </p-tablist>
      <p-tabpanels>
        <!-- ---------- Schedules ---------- -->
        <p-tabpanel value="schedules">
    <p-table [value]="rows()" [loading]="loading()" dataKey="id" [rows]="10"
      [paginator]="rows().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm"
      [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
      <ng-template pTemplate="header">
        <tr>
          <th>Schedule</th>
          <th>Report</th>
          <th>Scope</th>
          <th>Window</th>
          <th>Frequency</th>
          <th>Channels</th>
          <th class="ta-c" style="width: 90px">Active</th>
          <th class="ta-r" style="width: 190px">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td class="name">
            {{ r.scheduleName }}
            @if (r.lastRunAt) { <small class="sub-line">Last run: {{ ist(r.lastRunAt) }} IST</small> }
          </td>
          <td>
            <p-tag [value]="label(r.reportType)" [severity]="reportSeverity(r.reportType)" />
            @if (r.templateName) {
              <small class="sub-line" pTooltip="Column template"><i class="pi pi-table"></i> {{ r.templateName }}</small>
            }
          </td>
          <td>{{ scopeLabel(r) }}</td>
          <td>{{ label(r.reportWindow) }}</td>
          <td>
            {{ freqLabel(r) }}
            @if (r.isActive && r.nextRunAt) {
              <small class="sub-line next">Next: {{ ist(r.nextRunAt) }} IST</small>
            }
          </td>
          <td>
            <div class="channels">
              @if (r.isEmail) {
                <span class="chan" [pTooltip]="r.emails || ''">
                  <i class="pi pi-envelope"></i> {{ recipientCount(r.emails) }}
                </span>
              }
              @if (r.isWhatsApp) {
                <span class="chan wa" [pTooltip]="r.whatsAppNumbers || ''">
                  <i class="pi pi-whatsapp"></i> {{ recipientCount(r.whatsAppNumbers) }}
                </span>
              }
              @if (!r.isEmail && !r.isWhatsApp) { <span class="muted">—</span> }
            </div>
          </td>
          <td class="ta-c">
            <p-toggleSwitch [ngModel]="r.isActive" (ngModelChange)="toggleActive(r, $event)" />
          </td>
          <td class="ta-r actions">
            <p-button [icon]="runningId() === r.id ? 'pi pi-spin pi-spinner' : 'pi pi-play'"
              [rounded]="true" [text]="true" severity="secondary" [disabled]="runningId() !== null"
              pTooltip="Run now (delivers to everyone configured)" (onClick)="runNow(r)" />
            <p-button icon="pi pi-history" [rounded]="true" [text]="true" severity="secondary"
              pTooltip="Run logs" (onClick)="openLogs(r)" />
            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
              pTooltip="Edit" (onClick)="openEdit(r)" />
            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
              pTooltip="Delete" (onClick)="remove(r)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">
            <div class="state"><i class="pi pi-calendar-clock"></i>
              <p>No report schedules yet. Click <strong>New Schedule</strong> to create the first one.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
        </p-tabpanel>

        <!-- ---------- Templates ---------- -->
        <p-tabpanel value="templates">
    <p-table [value]="tplRows()" [loading]="tplLoading()" dataKey="id" [rows]="10"
      [paginator]="tplRows().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm"
      [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
      <ng-template pTemplate="header">
        <tr>
          <th>Template</th>
          <th>Report</th>
          <th>Columns</th>
          <th>Used By</th>
          <th class="ta-c" style="width: 90px">Active</th>
          <th>Created (IST)</th>
          <th class="ta-r" style="width: 110px">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-t>
        <tr>
          <td class="name">{{ t.templateName }}</td>
          <td><p-tag [value]="label(t.reportType)" [severity]="reportSeverity(t.reportType)" /></td>
          <td>{{ tplColumnsLabel(t) }}</td>
          <td>
            @if (t.usedBySchedules) {
              <span class="chan">{{ t.usedBySchedules }} schedule{{ t.usedBySchedules === 1 ? '' : 's' }}</span>
            } @else { <span class="muted">—</span> }
          </td>
          <td class="ta-c">
            <p-tag [value]="t.isActive ? 'Active' : 'Inactive'" [severity]="t.isActive ? 'success' : 'secondary'" />
          </td>
          <td class="nowrap">{{ ist(t.createdAt) }}</td>
          <td class="ta-r actions">
            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
              pTooltip="Edit" (onClick)="openTplEdit(t)" />
            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
              pTooltip="Delete" (onClick)="removeTpl(t)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">
            <div class="state"><i class="pi pi-table"></i>
              <p>No column templates yet. Click <strong>New Template</strong> to choose which columns a report's Excel contains.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>

<!-- ===================== CREATE / EDIT DIALOG ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true"
  [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
  [header]="editing() ? 'Edit Schedule' : 'New Report Schedule'" styleClass="menu-dialog"
  [style]="{ width: '640px' }" [breakpoints]="{ '700px': '94vw' }">
  <form [formGroup]="form" class="menu-form">

    <!-- ============ WHAT ============ -->
    <h3 class="section-title"><i class="pi pi-file-excel"></i> What</h3>

    <div class="field">
      <label>Schedule Name <span class="req">*</span></label>
      <input pInputText type="text" formControlName="scheduleName" placeholder="e.g. Daily COI - Arohan" maxlength="120">
      @if (form.get('scheduleName')?.touched && form.get('scheduleName')?.invalid) {
        <small class="err">Schedule name is required</small>
      }
    </div>

    <div class="grid-2">
      <div class="field">
        <label>Report Type <span class="req">*</span></label>
        <p-select formControlName="reportType" [options]="reportTypeOptions()" optionLabel="label"
          optionValue="value" placeholder="Select report" appendTo="body" [loading]="optionsLoading()" />
      </div>
      <div class="field">
        <label>Data Window <span class="req">*</span></label>
        <p-select formControlName="reportWindow" [options]="windowOptions()" optionLabel="label"
          optionValue="value" placeholder="Select window" appendTo="body" />
        @if (fReportWindow() === 'SAME_DAY') {
          <small class="hint-muted">Report covers today (IST) up to the run time — e.g. run at 23:00 for the full day's collection.</small>
        }
      </div>
    </div>

    <div class="field">
      <label>Report Template</label>
      <p-select formControlName="templateId" [options]="templateOptions()" optionLabel="label"
        optionValue="value" placeholder="All columns (default)" appendTo="body" [loading]="optionsLoading()" />
      <small class="hint-muted">Templates control which columns appear in the Excel. Manage them in the Templates tab.</small>
    </div>

    <div class="grid-2">
      <div class="field">
        <label>Scope <span class="req">*</span></label>
        <p-select formControlName="scopeType" [options]="scopeTypeOptions()" optionLabel="label"
          optionValue="value" placeholder="Select scope" appendTo="body" />
      </div>
      @if (fScopeType() === 'PARTNER') {
        <div class="field">
          <label>Partner <span class="req">*</span></label>
          <p-select formControlName="partnerId" [options]="partnerOptions()" optionLabel="label"
            optionValue="value" [filter]="true" filterBy="label" placeholder="Select partner" appendTo="body" />
        </div>
      } @else if (fScopeType() === 'CLIENT') {
        <div class="field">
          <label>Client <span class="req">*</span></label>
          <p-select formControlName="clientId" [options]="clientOptions()" optionLabel="label"
            optionValue="value" [filter]="true" filterBy="label" placeholder="Select client" appendTo="body" />
        </div>
      }
    </div>

    @if (fReportType() === 'PAYMENTS') {
      <div class="field">
        <label>Payment Statuses <small class="hint-muted">(empty = all statuses)</small></label>
        <p-multiselect formControlName="statusList" [options]="statusOptions()" optionLabel="label"
          optionValue="value" placeholder="All statuses" display="chip" appendTo="body" />
      </div>
    }

    <!-- ============ WHEN ============ -->
    <h3 class="section-title"><i class="pi pi-clock"></i> When</h3>

    <div class="grid-3">
      <div class="field">
        <label>Frequency <span class="req">*</span></label>
        <p-select formControlName="frequency" [options]="frequencyOptions()" optionLabel="label"
          optionValue="value" placeholder="Select frequency" appendTo="body" />
      </div>
      <div class="field">
        <label>Time (IST) <span class="req">*</span></label>
        <p-datepicker formControlName="runAtTime" [timeOnly]="true" hourFormat="12"
          appendTo="body" placeholder="08:00 AM" />
        @if (form.get('runAtTime')?.touched && form.get('runAtTime')?.invalid) {
          <small class="err">Pick the run time</small>
        }
      </div>
      @if (fFrequency() === 'WEEKLY') {
        <div class="field">
          <label>Day of Week <span class="req">*</span></label>
          <p-select formControlName="dayOfWeek" [options]="dayOfWeekOptions()" optionLabel="label"
            optionValue="value" placeholder="Select day" appendTo="body" />
        </div>
      } @else if (fFrequency() === 'MONTHLY') {
        <div class="field">
          <label>Day of Month <span class="req">*</span></label>
          <p-inputnumber formControlName="dayOfMonth" [min]="1" [max]="28" [useGrouping]="false" [showButtons]="true" />
          <small class="hint-muted">1–28 so every month has the day</small>
        </div>
      }
    </div>

    <!-- ============ DELIVERY ============ -->
    <h3 class="section-title"><i class="pi pi-send"></i> Delivery</h3>

    <div class="channel-block">
      <label class="switch-row">
        <p-toggleSwitch formControlName="isEmail" />
        <span><i class="pi pi-envelope"></i> Email <small>(one mail, file attached, all addresses)</small></span>
      </label>
      @if (fIsEmail()) {
        <div class="field indent">
          <label>Recipients <span class="req">*</span></label>
          <p-autocomplete formControlName="emailList" [multiple]="true" [typeahead]="false" [fluid]="true"
            placeholder="Type an address, press Enter" />
          <small class="hint-muted">Press Enter after each address.</small>
        </div>
      }
    </div>

    <div class="channel-block">
      <label class="switch-row">
        <p-toggleSwitch formControlName="isWhatsApp" />
        <span><i class="pi pi-whatsapp"></i> WhatsApp <small>(document message per number)</small></span>
      </label>
      @if (fIsWhatsApp()) {
        <div class="field indent">
          <label>Numbers <span class="req">*</span></label>
          <p-autocomplete formControlName="waList" [multiple]="true" [typeahead]="false" [fluid]="true"
            placeholder="10-digit or with 91, press Enter" />
          <small class="hint-muted">Press Enter after each number — 10 digits, or with country code 91.</small>
        </div>
      }
    </div>

    <div class="format-row">
      <span class="format-chip"><i class="pi pi-file-excel"></i> Excel (.xlsx)</span>
      <label class="switch-row active-row">
        <p-toggleSwitch formControlName="isActive" />
        <span>Active</span>
      </label>
    </div>

    <div class="modal-actions">
      <p-button label="Cancel" [outlined]="true" type="button" (onClick)="closeModal()" />
      <p-button [label]="saving() ? 'Saving...' : 'Save Schedule'" icon="pi pi-check" type="button"
        [loading]="saving()" [disabled]="saving()" (onClick)="save()" />
    </div>
  </form>
</p-dialog>

<!-- ===================== RUN LOGS DIALOG ===================== -->
<p-dialog [visible]="showLogs()" (visibleChange)="showLogs.set($event)" [modal]="true"
  [draggable]="true" [resizable]="false" [dismissableMask]="true"
  [header]="logsFor() ? 'Run Logs — ' + logsFor()!.scheduleName : 'Run Logs — All Schedules'"
  styleClass="menu-dialog" [style]="{ width: '860px' }" [breakpoints]="{ '900px': '96vw' }">
  <div class="logs-bar">
    <span class="hint-muted">Delivery is queued — the worker sends within ~30 seconds of a run.</span>
    <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary"
      pTooltip="Refresh" (onClick)="loadLogs()" />
  </div>

  <p-table [value]="logsRows()" [loading]="logsLoading()" dataKey="id" [rows]="10"
    [paginator]="logsRows().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm"
    [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
    <ng-template pTemplate="header">
      <tr>
        <th>Started (IST)</th>
        @if (!logsFor()) { <th>Schedule</th> }
        <th>Trigger</th>
        <th>Status</th>
        <th class="ta-r">Rows</th>
        <th>File</th>
        <th class="ta-c">Sent</th>
        <th>Error</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-l>
      <tr>
        <td class="nowrap">{{ ist(l.runStartedAt) }}</td>
        @if (!logsFor()) { <td class="name">{{ l.scheduleName || ('#' + l.scheduleId) }}</td> }
        <td><span class="mono">{{ l.triggeredBy }}</span></td>
        <td><p-tag [value]="l.status" [severity]="runSeverity(l.status)" /></td>
        <td class="ta-r">{{ l.rowCount }}</td>
        <td>
          @if (l.fileStorageKey || l.fileUrl) {
            <button type="button" class="file-link" [disabled]="downloadingId() !== null"
              (click)="downloadExcel(l)"
              pTooltip="Download the generated Excel (fetched securely from storage)">
              <i class="pi" [ngClass]="downloadingId() === l.id ? 'pi-spin pi-spinner' : 'pi-download'"></i> Excel
            </button>
          } @else { <span class="muted">—</span> }
        </td>
        <td class="ta-c">
          <span class="sent-cell">
            @if (l.emailsSent) { <span class="chan"><i class="pi pi-envelope"></i> {{ l.emailsSent }}</span> }
            @if (l.whatsAppSent) { <span class="chan wa"><i class="pi pi-whatsapp"></i> {{ l.whatsAppSent }}</span> }
            @if (!l.emailsSent && !l.whatsAppSent) { <span class="muted">—</span> }
          </span>
        </td>
        <td class="err-cell" [title]="l.errorMessage || ''">{{ l.errorMessage || '—' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="logsFor() ? 7 : 8">
          <div class="state"><i class="pi pi-history"></i><p>No runs yet. Use <strong>Run now</strong> to test a schedule.</p></div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- ===================== TEMPLATE DIALOG ===================== -->
<p-dialog [visible]="showTplModal()" (visibleChange)="showTplModal.set($event)" [modal]="true"
  [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
  [header]="tplEditing() ? 'Edit Template' : 'New Column Template'" styleClass="menu-dialog"
  [style]="{ width: '780px' }" [breakpoints]="{ '820px': '96vw' }">
  <form [formGroup]="tplForm" class="menu-form">

    <div class="grid-2">
      <div class="field">
        <label>Template Name <span class="req">*</span></label>
        <input pInputText type="text" formControlName="templateName" placeholder="e.g. Finance daily columns" maxlength="120">
        @if (tplForm.get('templateName')?.touched && tplForm.get('templateName')?.invalid) {
          <small class="err">Template name is required</small>
        }
      </div>
      <div class="field">
        <label>Report Type <span class="req">*</span></label>
        <p-select formControlName="reportType" [options]="tplReportTypeOptions" optionLabel="label"
          optionValue="value" appendTo="body" />
        @if (tplUsedBy() > 0) {
          <small class="hint-muted">Locked — {{ tplUsedBy() }} schedule(s) use this template.</small>
        }
      </div>
    </div>

    <div class="field">
      <label>Columns <span class="req">*</span></label>
      <p-picklist [source]="tplSource()" [target]="tplTarget()" [dragdrop]="true"
        [showSourceControls]="false" [showTargetControls]="true"
        sourceHeader="Available columns" targetHeader="In the Excel (in order)"
        [sourceStyle]="{ height: '260px' }" [targetStyle]="{ height: '260px' }" breakpoint="700px">
        <ng-template let-item pTemplate="item">
          <span class="pick-item">{{ item.label }}</span>
        </ng-template>
      </p-picklist>
      <small class="hint-muted">Move columns right to include them; drag (or use the arrows) to set their order in the Excel.</small>
    </div>

    <div class="format-row">
      <label class="switch-row active-row">
        <p-toggleSwitch formControlName="isActive" />
        <span>Active <small>(inactive templates can't be picked for new schedules)</small></span>
      </label>
    </div>

    <div class="modal-actions">
      <p-button label="Cancel" [outlined]="true" type="button" (onClick)="closeTplModal()" />
      <p-button [label]="tplSaving() ? 'Saving...' : 'Save Template'" icon="pi pi-check" type="button"
        [loading]="tplSaving()" [disabled]="tplSaving()" (onClick)="saveTpl()" />
    </div>
  </form>
</p-dialog>
